import initialState from './initial.state';
import * as ActionTypes from '../actions/types.action';

export default function checkoutDataReducer(state = initialState.checkoutData, action) {
  switch (action.type) {
    case ActionTypes.SET_CHECKOUTDATA_SUCCESS:
      return action.checkoutData;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/checkoutData.reducer.js